import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import { IconButton } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ListAltIcon from '@mui/icons-material/ListAlt';
import Logo from '../../../../shared/components/Logo';

interface Props {
  Resmenu: string;
}

const Resmenu: React.FC<Props> = ({ Resmenu }) => {
  const [clickmenu, setClickMenu] = useState(false);
  const [data, setData] = useState<any>(); 
  const [loading, setLoading] = useState(false);
  const openResmenu = useRef<HTMLDivElement>(null);
  const [overlayMenu, setOverlayMenu] = useState(false);
  const overlayRef = useRef<HTMLDivElement>(null);
  const [background, setbackground] = useState<any>("");
  const [employees, setEmployees] = useState<boolean>(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    
    handleResize()
    window.addEventListener('resize', handleResize);
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleDrawerToggle = () => {
    setOverlayMenu((prev) => !prev);
  };

  useEffect(() => {
    setLoading(true);
    const business = sessionStorage.getItem("organization_name")
    const storedColor = sessionStorage.getItem(`background_color${business}`);
    setData(business)
    const employeeLogin = sessionStorage.getItem("employee")
    if (employeeLogin) {
      setEmployees(true)
    } else {
      setEmployees(false)
    }
    
    if (storedColor) {
      setbackground(storedColor);
      document.documentElement.style.setProperty('--color', storedColor);
    }
    const fontfamily = sessionStorage.getItem(`font_family${business}`);
    if (fontfamily) {
      document.documentElement.style.setProperty('--fontfamily', fontfamily);
    }
    setLoading(!true);
  }, [background])

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div style={{ marginTop: "-60px" }}>
      {/* Hamburger Icon for Mobile */}
      {isMobileView && (
        <div className='res-hamburger-icon'>
          <IconButton onClick={toggleMenu}>
            {menuOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
        </div>
      )}

      {/* Menu Container */}
      <div className='Res_menu_container' style={{
        display: isMobileView ? (menuOpen ? 'block' : 'none') : 'block'
      }}>
        <div className={`res-menu-wrapper 
          ${clickmenu ? 'expanded' : 'collapsed'} 
          ${isMobileView ? 'mobile-view' : ''} 
          ${isMobileView && menuOpen ? 'open' : ''}`}
        >
          {clickmenu ? (
            <menu className='res-expanded-menu' ref={openResmenu}>
              {data && (
                <div className="res-expanded-menu-content">
                  <div  className="res-logo-placeholder"> </div>
                  <h3 className="res-organization-name"><i>{data}</i></h3>
                  <Link to={"/v1/Reshome"} className="menu_Res_select" >
                    <IconButton >
                      <HomeIcon
                        className="menu-icons"
                        style={{ fontSize: "30px" }}
                        id="Inventory_icon"
                      />
                    </IconButton>
                    <p>Home page</p>
                  </Link>
                  <Link to={"/v1/Dashboard"} className="menu_Res_select" >
                    <IconButton >
                      <DashboardRoundedIcon
                        className="menu-icons"
                        style={{ fontSize: "30px" }}
                        id="Inventory_icon"
                      />
                    </IconButton>
                    <p>Dashboard</p>
                  </Link>
                  <Link to={"/v1/Order"} className="menu_Res_select">
                    <IconButton>
                      <ListAltIcon
                        className="menu-icons"
                        style={{ fontSize: "30px" }}
                      />
                    </IconButton>
                    <p>Orders</p>
                     <Link to={"/v1/Ressettings/Resbranch"}  className="menu_Res_select">
                  <Tooltip title="Settings" placement="left" arrow>
                    <IconButton>
                      <SettingsSuggestIcon
                        className="menu-icon"
                        style={{ fontSize: "30px" }}
                      />
                    </IconButton>
                  </Tooltip>
                </Link>
                  </Link>
                </div>
              )}
            </menu>
          ) : (
            <menu className="res-collapsed-menu">
              <div className="res-logo-container"><Logo /></div>
              <Link to={"/v1/Resdeshboard"} className="menu_Res_select" >
                <Tooltip title="Dashboard" placement="left" arrow>
                  <IconButton >
                    <DashboardRoundedIcon
                      className="menu-icon"
                      id="Inventory_icon"
                      style={{ fontSize: "30px" }}
                    />
                  </IconButton>
                </Tooltip>
              </Link>
              <Link to={"/v1/Reshome"} className="menu_Res_select">
                <Tooltip title="Home" placement="left" arrow>
                  <IconButton>
                    <HomeIcon
                      className="menu-icon"
                      id="Home"
                      style={{ fontSize: "30px" }}
                    />
                  </IconButton>
                </Tooltip>
              </Link>
              <Link to={"/v1/Resorders"} className="menu_Res_select">
                <Tooltip title="orders" placement="left" arrow>
                  <IconButton>
                    <ListAltIcon
                      className="menu-icon"
                      style={{ fontSize: "30px" }}
                    />
                  </IconButton>
                </Tooltip>
              </Link>
              <Link to={"/v1/edit/location"} className="menu_Res_select">
                <Tooltip title="Settings" placement="left" arrow>
                  <IconButton>
                    <SettingsSuggestIcon
                      className="menu-icon"
                      style={{ fontSize: "30px" }}
                    />
                  </IconButton>
                </Tooltip>
              </Link>
            </menu>
          )}
          <button 
            className={`res-expand-button ${clickmenu ? 'expanded' : ''}`}
            id="Expandbtn"
            onClick={() => setClickMenu(!clickmenu)}
          >
            {clickmenu ? (
           <ArrowBackIosIcon className="res-expand-icon res-expand-icon-back" />
           ) : (
           <ArrowForwardIosIcon className="res-expand-icon res-expand-icon-forward" />
           )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Resmenu;